import { Container } from "react-bootstrap";
import { useParams } from "react-router";
import allControls from "./controls.json";

function FamilyHome() {
  let { familyId } = useParams();
  let family = allControls.find((c) => c.Family === familyId);
  return (
    <Container className="py-4">
      <h2>
        {family.Name} ({family.Family})
      </h2>
    </Container>
  );
}

export default FamilyHome;
